{
  "timeValidationError": "Los minutos deben ser de 00 a 59",
  "startEndTimeValidationError": "La hora de finalización debe ser posterior a la hora de inicio",
  "Eq": "Igual",
  "Gt": "Mayor que",
  "Gte": "Mayor o igual a",
  "Lt": "Menor que",
  "Lte": "Menor o igual a",
  "Ct": "Contiene",
  "deleteRow": "Eliminar fila",
  "addRow": "Agregar nueva fila",
  "addColumn": "Agregar columna",
  "deleteAll": "Eliminar todo",
  "uploadData": "Subir datos",
  "deleteExisting": "Eliminar los elementos existentes",
  "keepExisting": "Conservar los artículos existentes",
  "downloadData": "Descargar datos",
  "schedule": {
    "day": "Día",
    "date": "Fecha",
    "start": "Inicio",
    "end": "Finalizar",
    "duration": "Duración (minutos)",
    "venue": "Lugar",
    "space": "Espacio",
    "type": "Tipo",
    "Discipline": "Discipl",
    "zero": "Cero",
    "description": "Descripción"
  },
  "toasts": {
    "edit_success": "Celda editada correctamente",
    "edit_error": "Error al editar la celda, considere la posibilidad de actualizar las celdas",
    "insert_success": "Se agregó correctamente {{ type }}",
    "insert_error": "Error al insertar la fila, considere actualizar las celdas",
    "delete_success": "La entidad de fila se eliminó correctamente",
    "delete_error": "Se ha producido un error al eliminar la fila. Considere la posibilidad de actualizar las celdas",
    "refresh_cells": "Actualiza las celdas"
  },
  "dataTable": {
    "filter": {
      "equals": "Igual",
      "greaterThan": "Mayor que",
      "greaterThanOrEqualTo": "Mayor o igual a",
      "lessThan": "Menor que",
      "lessThanOrEqualTo": "Menor o igual a",
      "contains": "Contiene",
      "select_all": "Seleccione todo"
    }
  },
  "type_something": "Escriba {{ name }}",
  "group": "Grupo",
  "count_column_header": "(Contar)",
  "none_group": "Ninguno",
  "Export selected rows only": "Exportar solo las filas seleccionadas",
  "Export all": "Exportar todas",
  "from": "¿Desde",
  "to": "Para"
}